import {Model} from './model';

export const DEFAULT_AVATAR_PATH = 'assets/images/avatars/default.svg';

export class Avatar extends Model {
  name: string;
  image: string;
  min_audits: number;
}
